var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApps = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.979 2.571c2.22 0 3.272.204 4.366.788a5.53 5.53 0 0 1 2.295 2.296c.585 1.094.789 2.147.789 4.366v3.957c0 2.22-.204 3.273-.789 4.367a5.53 5.53 0 0 1-2.295 2.295c-1.094.585-2.147.788-4.366.788H10.02c-2.22 0-3.272-.203-4.366-.788a5.53 5.53 0 0 1-2.295-2.296c-.585-1.093-.789-2.146-.789-4.366v-3.957c0-2.22.204-3.272.789-4.366A5.53 5.53 0 0 1 5.655 3.36c1.094-.584 2.147-.788 4.366-.788h3.958Zm0 1.715H10.02c-1.96 0-2.746.151-3.557.585A3.816 3.816 0 0 0 4.87 6.464c-.434.81-.585 1.597-.585 3.557v3.957c0 1.961.151 2.747.585 3.558a3.816 3.816 0 0 0 1.593 1.592c.811.434 1.597.586 3.557.586h3.958c1.96 0 2.746-.152 3.557-.585a3.817 3.817 0 0 0 1.593-1.593c.434-.811.585-1.597.585-3.558v-3.957c0-1.96-.151-2.746-.585-3.557a3.817 3.817 0 0 0-1.593-1.593c-.811-.434-1.597-.585-3.557-.585Zm-4.55 8.571a1.714 1.714 0 1 1 0 3.429 1.714 1.714 0 0 1 0-3.429Zm5.142 0a1.714 1.714 0 1 1 0 3.429 1.714 1.714 0 0 1 0-3.429ZM9.43 7.714a1.714 1.714 0 1 1 0 3.429 1.714 1.714 0 0 1 0-3.429Zm5.142 0a1.714 1.714 0 1 1 0 3.429 1.714 1.714 0 0 1 0-3.429Z",
    fill: "currentColor"
  })));
};
export default SvgApps;